<ng-container *transloco="let t">
  <div class="flex flex-col gap-4">
    <div class="flex flex-col gap-4">
      <div>
        <IFormField>
          <label iLabel>{{ t("data-warehouse-edition.share_name") }}</label>
          <input
            iInput
            [formControl]="editionForm.controls.shareName"
            [placeholder]="t('data-warehouse-edition.share_name_description')"
            [maxLength]="SHARE_NAME_MAX_LENGTH"
            size="md"
          />
          <IError>{{ t("data-warehouse-edition.share_name_error_pattern") }}</IError>
        </IFormField>

        @if (!isUpdate) {
          <p class="mt-1.5 text-xs text-gray-700">
            {{ t("data-warehouse-edition.non_editable_field_warning") }}
          </p>
        }
      </div>
      <label class="block text-sm font-medium text-gray-700">
        {{ t("data-warehouse-edition.location") }}
      </label>
      <div>
        <ISelectMenu
          [value]="editionForm.controls.gcLocation.value"
          (valueChange)="selectGCLocation($event)"
          fitTriggerWidth
          [(searchQuery)]="searchQuery"
          [disabled]="isUpdate"
        >
          <ISelectTrigger class="flex w-full">
            <ISelectValue [placeholder]="t('data-warehouse-edition.select_location')" />
          </ISelectTrigger>
          <ISelectContent>
            @for (location of filteredGCloudLocations(); track location) {
              <ISelectOption [value]="location">
                {{ location }}
              </ISelectOption>
            }
          </ISelectContent>
        </ISelectMenu>
        @if (!isUpdate) {
          <p class="mt-1.5 text-xs text-gray-700">
            {{ t("data-warehouse-edition.non_editable_field_warning") }}
          </p>
        }
      </div>

      <label class="block text-sm font-medium text-gray-700">
        {{ t("data-warehouse-edition.account_marketplace") }}
      </label>
      @if (hasAccountMarketplacesSelected()) {
        <div class="rounded-lg border border-gray-300 p-2.5">
          @for (selectedAccountMarketplaceGroup of selectedAccountMarketplaceGroups(); track $index) {
            <div class="my-1 flex text-sm">
              <span
                >{{ selectedAccountMarketplaceGroup.accountName }} ({{
                  selectedAccountMarketplaceGroup.marketplaces.length
                }})
              </span>
              @for (marketplace of selectedAccountMarketplaceGroup.marketplaces; track $index) {
                <div class="ml-2 flex items-center gap-0.5">
                  <IMarketplaceFlag [marketplace]="marketplace" />
                  <span class="text-sm text-gray-500">{{ marketplace }}</span>
                </div>
              }
            </div>
          }
        </div>
        <div class="rounded-lg border border-gray-200">
          <button iButton variant="secondary" size="sm" class="w-full" (click)="openAccountSelectionModal()">
            {{ t("data-warehouse-edition.update_account_marketplace_list") }}
          </button>
        </div>
      } @else {
        <button iButton variant="secondary" size="md" (click)="openAccountSelectionModal()">
          {{ t("data-warehouse-edition.select_account_marketplace") }}
        </button>
      }
      <label class="block text-sm font-medium text-gray-700">
        {{ t("data-warehouse-edition.cloud_permission_tittle") }}
      </label>
      <p
        class="mb-1 text-xs text-gray-500 dark:text-gray-400"
        [innerHTML]="
          t('data-warehouse-edition.cloud_permission_description', {
            officialDocumentationLink:
              '<a class=&quot;text-blue-600&quot; href=&quot;https://cloud.google.com/iam/docs/granting-changing-revoking-access&quot; target=_blank>' +
              t('data-warehouse-edition.cloud_permission_description_link') +
              '</a>',
          })
        "
      ></p>
      @for (emailCtrl of editionForm.controls.emails.controls; let i = $index; track $index) {
        <div class="flex">
          <IFormField>
            <input
              iInput
              class="flex-1"
              [placeholder]="t('data-warehouse-edition.google_email')"
              size="md"
              [formControl]="emailCtrl"
            />
            <IError>{{ t("profile-settings.invalid_email") }}</IError>
          </IFormField>

          @if (editionForm.controls.emails.controls.length > 1) {
            <button iButton variant="secondary" class="ml-3" (click)="removeGoogleCloudAccountLine(i)">
              <IIcon name="trash" />
            </button>
          }
        </div>
      }
      <button iButton variant="secondary" size="md" class="w-fit py-2" (click)="addGoogleCloudAccountLine()">
        <IIcon name="plus" />
      </button>
      <div class="flex justify-end gap-2">
        <button iButton variant="secondary" size="md" class="px-3" (click)="cancel()">
          {{ t("common.cancel") }}
        </button>
        <button
          iButton
          size="md"
          [loading]="loading()"
          [disabled]="!isValid()"
          (click)="isUpdate ? update() : create()"
        >
          {{ isUpdate ? t("common.update") : t("common.create") }}
        </button>
      </div>
    </div>
  </div>
</ng-container>
